var OLAPIC_CONFIG = {
  Classic: {
    'fr-FR': {
      apikey: 'e4cf48ac99036c376bf5818f8aad3fe04a1f03cf4256b25dd64526c58ada71c6',
      mobileId: '65c3eccd2c21dc18faca28700ddf8f55',
      desktopId: '2a26d3ef2b56abac0fece756914b6efc',
      lang: 'fr_FR'
    },
    'nl-BE': {
      apikey: 'a327a37b57205e24a0341ace342aef677a7c595b5407a6d8955f3bd3689daa73',
      mobileId: 'bfc98473d117fe992c80eb8aa2269f73',
      desktopId: '3c8dbe7b8ec53eaceecf2db84dd7c712',
      lang: 'nl_BE'
    },
    'fr-BE': {
      apikey: '0c16024a92390611327c7f2a11b61276ec04b508be31a3e04ebc195ba681c711',
      mobileId: '56ad250ba4e8068737c94a72c226b348',
      desktopId: '667bb2e2756b29107be8aa2e623dbe6b',
      lang: 'fr_BE'
    },
    'de-DE': {
      apikey: '3cf48833d7722d7cbf2e2b9c1cdc2d84c2fb3728b60bcd8a3ae23c42d47bcc6c',
      mobileId: '6d408c1c4e469897df03f529967f9f98',
      desktopId: '5edcef9de6efd2f66262c1e16812e405',
      lang: 'de_DE'
    },
    'es-ES': {
      apikey: '819d20f07da2468d4495a0fe2dab6e1275ee120beb942c34a5517ef21596bf9c',
      mobileId: '809df52562bf8881373363480fe44f5e',
      desktopId: '0919b7eb6a360952824b0b89e6a28fc1',
      lang: 'es_ES'
    },
    'it-IT': {
      apikey: '1090e707571449abb9d41515fce7f66c59136baaf048a75bd7257c655ce8024e',
      mobileId: 'd0a125cca0dac60fb4cb5cf32deb0577',
      desktopId: '1fe4d17fb99dfa2e4f1767f992af563a',
      lang: 'it_IT'
    },
    'fr-LU': {
      apikey: '7113222d43412b0e26195e166c8a2cf4bf123e495dca323375489838b64374bd',
      mobileId: 'dd1c39285fcdf76a7c6f16a9d7214f05',
      desktopId: '89cbda061c2d54ea9049ca60d0b145a5',
      lang: 'fr_LU'
    },
    'nl-NL': {
      apikey: 'c753c6fcefd8dc0b63b7afeb585ca80daf2e473aae37e9177cd73114a550d4bc',
      mobileId: '2240681567bed505edeeabe4edde3b5b',
      desktopId: 'd8e06e2f031b6537e7ce93f0425b1121',
      lang: 'nl_NL'
    },
    'de-AT': {
      apikey: '1367312d093e39af4dcc421565f8d756e668674663ac409a2040d8ae1a7f8e1d',
      mobileId: 'd2c429d978bf0cd1ed7ba18031a312b6',
      desktopId: '4954ae67945e34ebcba3d07dc9e2bd29',
      lang: 'de_AT'
    },
    'pt-PT': {
      apikey: '3fb20dbfb374ff71ba314624b0bed6e9ec1f551a20fc563ae6a70df48dd9f72c',
      mobileId: 'f2b6f9d3034797fcf201ed270eb1b0d4',
      desktopId: 'b554fdb14f5e3721cda44c06e61042ee',
      lang: 'pt_PT'
    },
    'de-CH': {
      apikey: 'c99366737aee22577564b10f7659d69f6ecf44cfe9d3cd9d37dd4f7acf4ddcd3',
      mobileId: '50052ec1a90bfae2f915fe1c03eb9c3b',
      desktopId: 'b8dfc2375a169eeef1a18a0b1a060577',
      lang: 'de_CH'
    },
    'it-CH': {
      apikey: '45c1b61996619cf1a56ce5d889bf4f478f8d5fe857d909b1f48311bc0dc8558a',
      mobileId: '064de5061dce1ac127e880f6f681a457',
      desktopId: 'c54a52fa3d88467c95b2b2fee5e3ff41',
      lang: 'it_CH'
    },
    'fr-CH': {
      apikey: 'e20997034a1676b427767001fe0cd03ab4b56d56d397fe2106d87f84207eddde',
      mobileId: 'f4ffd68c58ecc366367be18e91649593',
      desktopId: '9986c216e5546fda4693cf8494f705c6',
      lang: 'fr_CH'
    },
    'en-GB': {
      apikey: 'fe7e5f11755d70f4cc6aa6f274370bee21dd92c31626a1e7d256775351b51749',
      mobileId: '1c18a50c649406d3958a35a8bd403447',
      desktopId: '78cf8fba82ed7a477a0bda13ff7c1d57',
      lang: 'en_UK'
    }
  },
  Christmas: {
    'fr-FR': {
      apikey: 'e4cf48ac99036c376bf5818f8aad3fe04a1f03cf4256b25dd64526c58ada71c6',
      mobileId: '4e0bcb7ba687e28d1f9bd0af8bff047b',
      desktopId: '8ed14d2cb5cb757cb101df243a3c5688',
      lang: 'fr_FR'
    },
    'nl-BE': {
      apikey: 'a327a37b57205e24a0341ace342aef677a7c595b5407a6d8955f3bd3689daa73',
      mobileId: '9982b168df8853e9ef24b71041abf1e3',
      desktopId: 'f9bef9ec3b10f80b27bd7a70420192cd',
      lang: 'nl_BE'
    },
    'fr-BE': {
      apikey: '0c16024a92390611327c7f2a11b61276ec04b508be31a3e04ebc195ba681c711',
      mobileId: '08e9c85c8eafaf83ae38e4d16022b678',
      desktopId: 'bef1fafed74cbeb21b667e33c9b2d176',
      lang: 'fr_BE'
    },
    'de-DE': {
      apikey: '3cf48833d7722d7cbf2e2b9c1cdc2d84c2fb3728b60bcd8a3ae23c42d47bcc6c',
      mobileId: '45df0cea32d973fa7d740e68ebf54823',
      desktopId: 'd4da9e2aa067d18d35fafa2786c7f2c0',
      lang: 'de_DE'
    },
    'es-ES': {
      apikey: '819d20f07da2468d4495a0fe2dab6e1275ee120beb942c34a5517ef21596bf9c',
      mobileId: '7ac0f5f92de3474c950bc22eff4455bc',
      desktopId: '222a494a140941355e7bcb2394f11fc6',
      lang: 'es_ES'
    },
    'it-IT': {
      apikey: '1090e707571449abb9d41515fce7f66c59136baaf048a75bd7257c655ce8024e',
      mobileId: 'a790d109ab723511472963c6c94baac6',
      desktopId: '9c044309ca62da971ce3dd7522c31437',
      lang: 'it_IT'
    },
    'fr-LU': {
      apikey: '7113222d43412b0e26195e166c8a2cf4bf123e495dca323375489838b64374bd',
      mobileId: 'bb46e37cf02513d17df98805d0bb4301',
      desktopId: '7e38acdcf60ffa59cf9f7cc4e657ec07',
      lang: 'fr_LU'
    },
    'nl-NL': {
      apikey: 'c753c6fcefd8dc0b63b7afeb585ca80daf2e473aae37e9177cd73114a550d4bc',
      mobileId: '6ba8ff6f87e568ea9aca500c7196a47a',
      desktopId: 'bb39dc34df078f4dbdc92af042c513a4',
      lang: 'nl_NL'
    },
    'de-AT': {
      apikey: '1367312d093e39af4dcc421565f8d756e668674663ac409a2040d8ae1a7f8e1d',
      mobileId: '0c74b7e2107fd8f457f43470e5b9b788',
      desktopId: '965a11341b1d4f4b1ef5ed6513d13c11',
      lang: 'de_AT'
    },
    'pt-PT': {
      apikey: '3fb20dbfb374ff71ba314624b0bed6e9ec1f551a20fc563ae6a70df48dd9f72c',
      mobileId: 'bfb346ae5475a77d15ad7aec5387a8dd',
      desktopId: 'b4bf0f356a96fcab145cc774a4011445',
      lang: 'pt_PT'
    },
    'de-CH': {
      apikey: 'c99366737aee22577564b10f7659d69f6ecf44cfe9d3cd9d37dd4f7acf4ddcd3',
      mobileId: '0f4d7ee3e6ade3169b11e1f60aca78b3',
      desktopId: 'fbc6fde58ce8fd28097722cd49711332',
      lang: 'de_CH'
    },
    'it-CH': {
      apikey: '45c1b61996619cf1a56ce5d889bf4f478f8d5fe857d909b1f48311bc0dc8558a',
      mobileId: 'a790d109ab723511472963c6c94baac6',
      desktopId: '646b66a0415f1f301e38d0efef0d9699',
      lang: 'it_CH'
    },
    'fr-CH': {
      apikey: 'e20997034a1676b427767001fe0cd03ab4b56d56d397fe2106d87f84207eddde',
      mobileId: '0a81dfc78a97e6afd6a85c9c65e58d16',
      desktopId: '277c64de5e538c1fafb0d0a924588a66',
      lang: 'fr_CH'
    },
    'en-GB': {
      apikey: 'fe7e5f11755d70f4cc6aa6f274370bee21dd92c31626a1e7d256775351b51749',
      mobileId: 'a21039e46a5c45e87513ba38bc2f2492',
      desktopId: '7c2fc4f8024bcf6bba39c62211591351',
      lang: 'en_UK'
    }
  }
};
export default OLAPIC_CONFIG;